"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createDefaultTheme = void 0;
var _styles = require("@mui/material/styles");
var _react = _interopRequireDefault(require("react"));
var _Colors = _interopRequireDefault(require("./Colors"));
var _Typography = require("../components/Typography");
var _Divider = require("../components/Divider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DEFAULT_BOX_SIZING = 'border-box';
var createDefaultTheme = function createDefaultTheme() {
  return (0, _styles.createTheme)(_objectSpread({
    palette: {
      primary: {
        main: _Colors.default.orange
      },
      secondary: {
        main: _Colors.default.textElementGrey
      },
      error: {
        main: _Colors.default.dangerRed
      },
      warning: {
        main: _Colors.default.warningYellow
      },
      info: {
        main: _Colors.default.infoBlue
      },
      success: {
        main: _Colors.default.acceptGreen
      },
      divider: _Divider.DEFAULT_DIVIDER_COLOR
    },
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true
        }
      }
    },
    typography: {
      fontFamily: _Typography.TYPOGRAPHY_BASE_FONT_FAMILY
    }
  }, {
    boxSizing: DEFAULT_BOX_SIZING
  }));
};
exports.createDefaultTheme = createDefaultTheme;
var ThemeProvider = function ThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? createDefaultTheme : _ref$theme,
    _ref$extendTheme = _ref.extendTheme,
    extendTheme = _ref$extendTheme === void 0 ? {} : _ref$extendTheme,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_styles.StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: _objectSpread(_objectSpread({}, typeof theme === 'function' ? theme() : theme), extendTheme)
  }, children));
};
var _default = ThemeProvider;
exports.default = _default;